import React, { useContext, useEffect, useRef, useState } from 'react'
import deeplab_v3_model from '../assets/models/deeplab_v3.tflite'; // Asegúrate de que la ruta sea correcta
import selfie_segmenter_landscape from '../assets/models/selfie_segmenter_landscape.tflite'; // Asegúrate de que la ruta sea correcta
import selfie_segmenter_general from '../assets/models/selfie_segmenter.tflite'; // Asegúrate de que la ruta sea correcta
import selfie_multiclass from '../assets/models/selfie_multiclass.tflite'; // Asegúrate de que la ruta sea correcta
import { ImageSegmenter, FilesetResolver } from "@mediapipe/tasks-vision";
import { applyGreenMask, applyBinaryMask, applyBlurMask, applyImageMask } from "./CanvasProcessing"

const SegmenterProviderContext = React.createContext();
export function useSegmenterProvider() {
    return useContext(SegmenterProviderContext)
}

export function SegmenterProvider({ children }) {

    const segmenterModel = useRef(null);
    const [statusSegmenter, setStatusSegmenter] = useState(false);
    const statusSegmenterRef = useRef(statusSegmenter);

    const [configModelSegmenter, setConfigModelSegmenter] = useState('SELFIE_GENERAL');
    const [configDelegateSegmenter, setConfigDelegateSegmenter] = useState('CPU');
    const [configThresholdSegmenter, setConfigThresholdSegmenter] = useState(0.5);

    const [configCanvasOutBlurringActivate, setConfigCanvasOutBlurringActivate] = useState(false)
    const [configCanvasOutBlurringPixels, setConfigCanvasOutBlurringPixels] = useState(5)

    // const [configTypeCanvas, setConfigTypeCanvas] = useState(0.5);
    // const [configIntensitivyBlur, setConfigIntensitivyBlur] = useState(0.5);

    const configThresholdSegmenter_ref = useRef(configThresholdSegmenter);
    const configCanvasOutBlurringPixels_ref = useRef(configCanvasOutBlurringPixels);

    const options_models_available= {
        'SELFIE_GENERAL': selfie_segmenter_general,
        'SELFIE_LANDSCAPE': selfie_segmenter_landscape,
        'DEEPLAB_V3': deeplab_v3_model,
        'SELFIE_MULTICLASS': selfie_multiclass,
    }

    const segmentationDataRef = useRef(null);
    const segmentationDataBufferRef = useRef(null);


    const initializeSegmenters = async (model, delegate) => {
        console.log("🚀 ~ Segmenter ~ initializeSegmenters:", initializeSegmenters)

        segmenterModel.current = await ImageSegmenter.createFromOptions(await FilesetResolver.forVisionTasks("https://cdn.jsdelivr.net/npm/@mediapipe/tasks-vision@latest/wasm"), {
            baseOptions: {
              modelAssetPath: model,
              delegate: delegate
            },
            outputCategoryMask: true,
            outputConfidenceMasks: true,
            runningMode: 'VIDEO'
        });

        statusSegmenterRef.current = true;

        console.log("🚀 ~ Segmenter ~ segmenterModel.current:", segmenterModel.current)
    };
    

    // useEffect(() => {
    //     const initializeSegmenters = async (modelSegmenter, delegate) => {
    //         segmenterModel.current = await createImageSegmenter(options_models_available[modelSegmenter], 'VIDEO', delegate)
    //     };

    //     segmenterModel.current = initializeSegmenters(options_models_available.SELFIE_GENERAL, 'VIDEO', 'GPU')
    // }, [])

    useEffect(() => {
        if (statusSegmenter){
            initializeSegmenters(options_models_available.SELFIE_GENERAL, 'GPU');
        }
        else{
            segmenterModel.current = null
            statusSegmenterRef.current = false;
        }
    }, [statusSegmenter, configModelSegmenter, configDelegateSegmenter])

    useEffect(() => {
        configThresholdSegmenter_ref.current = configThresholdSegmenter
    }, [configThresholdSegmenter])

    useEffect(() => {
        configCanvasOutBlurringPixels_ref.current = configCanvasOutBlurringPixels
    }, [configCanvasOutBlurringPixels])
    

    async function applySegmentationOnCanvas(streamImageBitmapRef, streamCanvasRef, streamContextRef){
        console.log("🚀 ~ StreamCanvas ~ applySegmentationOnCanvas PRE:")
        if (statusSegmenterRef.current) {
            streamImageBitmapRef.current = await createImageBitmap(streamCanvasRef.current);
            segmentationDataRef.current = await segmenterModel.current.segmentForVideo(streamImageBitmapRef.current, performance.now());
            if (segmentationDataRef.current && segmentationDataRef.current.confidenceMasks) {
                applyGreenMask(streamContextRef.current, segmentationDataRef.current.confidenceMasks, streamCanvasRef.current.width, streamCanvasRef.current.height, configModelSegmenter, configThresholdSegmenter_ref.current)
                // if ( maskOperation == "GREEN" ) applyGreenMask(context.current, segmentationDataRef.current.confidenceMasks, canvas.current.width, canvas.current.height, configModelSegmenter, configThresholdSegmenter_ref.current)
                // if ( maskOperation == "BW" ) applyBinaryMask(context.current, segmentationDataRef.current.confidenceMasks, canvas.current.width, canvas.current.height, configModelSegmenter, configThresholdSegmenter_ref.current)
                // if ( maskOperation == "BLUR" ) applyBlurMask(context.current, segmentationDataRef.current.confidenceMasks, canvas.current.width, canvas.current.height, configModelSegmenter, configThresholdSegmenter_ref.current, configCanvasOutBlurringPixels_ref.current)
                // if ( maskOperation == "IMAGE" ) applyImageMask(context.current, segmentationDataRef.current.confidenceMasks, canvas.current.width, canvas.current.height, configModelSegmenter, configThresholdSegmenter_ref.current)
            }
        }
        return Promise.resolve();
    }


    /* Exported values */
    const value = {
        statusSegmenter,
        setStatusSegmenter,
        statusSegmenterRef,

        applySegmentationOnCanvas,

        configModelSegmenter,
        configDelegateSegmenter,
        configThresholdSegmenter,
        setConfigModelSegmenter,
        setConfigDelegateSegmenter,
        setConfigThresholdSegmenter,

        // configCanvasOutBlurringActivate,
        // setConfigCanvasOutBlurringActivate,
        // configCanvasOutBlurringPixels,
        // setConfigCanvasOutBlurringPixels,

        options_models_available
    }

    return (
        <SegmenterProviderContext.Provider value={value}>
            {children}
        </SegmenterProviderContext.Provider>
    )
}